
import {routerPaths} from '../../../router/routerPaths'
import permissions from "../../../router/middleware/permissions";
import {PERMISSIONS} from "../../../staticData/permissionsStatic";

const DHLReturnTable = () => import(/* webpackChunkName: "group-dhl-return-table" */ './components/DHLReturnTable/DHLReturnTable.vue')
const DHLReturnCreation = () => import(/* webpackChunkName: "group-dhl-return-creating" */ './components/DHLReturnCreation/DHLReturnCreation.vue')
const DHLReturnEdit = () => import(/* webpackChunkName: "group-dhl-return-edit" */ './components/DHLReturnEdit/DHLReturnEdit.vue')
const DHLReturnShow = () => import(/* webpackChunkName: "group-dhl-return-show" */ './components/DHLReturnShow/DHLReturnShow.vue')
const moduleKey = 'dhl-return'

export const DHLReturnRoutes = [
  {
    path: routerPaths.DHLReturn,
    component: DHLReturnTable,
    meta: {
      breadcrumbs: {
        key: [
          'warehouse',
          'DHLReturn'
        ],
        items: {
          'warehouse': {
            name: 'menu_ordersDispatches',
            link: routerPaths.DHLReturn,
          },
          'DHLReturn': {
            name: 'breadcrumbs_NewDHLReturnOrder',
            link: routerPaths.DHLReturn,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.RETURN_PARCEL_DHLPL_RETURN],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_NewDHLReturnOrder'
    },
  },
  {
    path: routerPaths.DHLReturnCreation,
    component: DHLReturnCreation,
    meta: {
      breadcrumbs: {
        key: [
          'warehouse',
          'DHLReturn',
        ],
        items: {
          'warehouse': {
            name: 'menu_ordersDispatches',
            link: routerPaths.DHLReturn,
          },
          'DHLReturn': {
            name: 'breadcrumbs_NewDHLReturnOrder',
            link: routerPaths.DHLReturnCreation,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.RETURN_PARCEL_DHLPL_RETURN],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_NewDHLReturnOrder'
    },
  },
  {
    path: routerPaths.DHLReturnEdit,
    component: DHLReturnEdit,
    meta: {
      breadcrumbs: {
        key: [
          'warehouse',
          'DHLReturn',
        ],
        items: {
          'warehouse': {
            name: 'menu_ordersDispatches',
            link: routerPaths.DHLReturn,
          },
          'DHLReturn': {
            name: 'breadcrumbs_NewDHLReturnOrder',
            link: routerPaths.DHLReturnEdit,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.RETURN_PARCEL_DHLPL_RETURN],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_EditDHLReturn'
    },
  },
  {
    path: routerPaths.DHLReturnShow,
    component: DHLReturnShow,
    meta: {
      breadcrumbs: {
        key: [
          'warehouse',
          'DHLReturn',
        ],
        items: {
          'warehouse': {
            name: 'menu_ordersDispatches',
            link: routerPaths.DHLReturn,
          },
          'DHLReturn': {
            name: 'breadcrumbs_NewDHLReturnOrder',
            link: routerPaths.DHLReturnShow,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.RETURN_PARCEL_DHLPL_RETURN],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_NewDHLReturnOrder'
    },
  },
]
